import { MarkdownContent } from "@/components/ui/markdown-content";

interface QuestionContentProps {
  content: string;
}

export function QuestionContent({ content }: QuestionContentProps) {
  return <MarkdownContent>{content}</MarkdownContent>;
}
